var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 11 6", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.826 4.298C7.121 3.001 8.415 1.704 9.714.412a.741.741 0 0 1 .303-.189.45.45 0 0 1 .512.23.474.474 0 0 1-.071.56c-.025.028-.053.053-.079.08L6.1 5.375c-.285.285-.528.287-.81.005L.986 1.076C.863.954.776.82.796.641a.451.451 0 0 1 .3-.398.457.457 0 0 1 .502.094c.098.09.19.187.283.28 1.224 1.226 2.448 2.45 3.67 3.676.042.041.076.09.15.178.056-.079.085-.132.125-.173z", fillRule: "evenodd" })
  );
});